import { Box, SecondaryButton, useModal } from '@shape-ds/components';
import MaintenanceNotesTable from 'components/ExternalReferencesTables/MaintenanceNotesTable';
import { EventItem } from 'queries/events/types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import AckButton from './AckButton/AckButton';
import SimilarEventList from './SimilarEventList/SimilarEventList';
import './style.scss';
import RecordsOpenModal from '../../../Records/RecordsButton/RecordsOpenModal';
import { ASSET_PAGE } from 'config/paths';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import ListCases from 'components/Cases/List/ListCases';
import { useCaseOpenedCount } from 'pages/Asset/tabs/Cases/hooks/useCaseOpenedCount';

interface EventFooterProps {
  event: EventItem;
  setSelectedRow?: (row?: EventItem) => void;
}

const EventFooter: React.FC<EventFooterProps> = ({ event, setSelectedRow }) => {
  const { openModal } = useModal();
  const { t } = useTranslation();

  const count = useCaseOpenedCount(event.asset.id);

  const handleOpenSimilarEvents = useCallback(() => {
    openModal(<SimilarEventList assetId={event.asset.id} eventId={event.id} showTitle />, {
      width: '840px',
    });
  }, [event.asset.id, event.id, openModal]);

  const handleOpenMaintenance = useCallback(() => {
    openModal(<MaintenanceNotesTable assetId={event.asset.id} />, {
      title: t('event_page:components.maintenanceModal'),
      width: '840px',
    });
  }, [event.asset.id, openModal, t]);

  const handleOpenAssetPage = useCallback(() => {
    window.open(ASSET_PAGE(event.asset.id), '_blank');
  }, [event.asset.id]);

  return (
    <Box className="event-footer">
      <div className="footer-btns">
        <div className="event-footer-btns-wrapper">
          <SecondaryButton onClick={handleOpenAssetPage} startIcon={<LaunchOutlinedIcon />}>
            {t('event_page:components.eventFooter.btns.assetPage')}
          </SecondaryButton>

          <SecondaryButton onClick={handleOpenSimilarEvents}>
            {t('event_page:components.similarEventsList.btn')}
          </SecondaryButton>

          <SecondaryButton
            onClick={() =>
              openModal(<ListCases asset={event.asset} maxHeight={300} showTitle />, {
                PaperProps: { style: { padding: 0 }, className: 'listcase-modal' },
              })
            }
          >
            {t('event_page:components.eventFooter.btns.cases')} ({count})
          </SecondaryButton>

          <SecondaryButton onClick={handleOpenMaintenance}>
            {t('event_page:components.eventFooter.btns.maintenance')}
          </SecondaryButton>

          <RecordsOpenModal id={event.id} />
        </div>
        <AckButton event={event} setSelectedRow={setSelectedRow} />
      </div>
    </Box>
  );
};

export default EventFooter;
